import { render, staticRenderFns } from "./SessionTypeRoom.vue?vue&type=template&id=63e31b90"
import script from "./SessionTypeRoom.vue?vue&type=script&lang=js"
export * from "./SessionTypeRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports